import { render, staticRenderFns } from "./ApplicantsViewer.vue?vue&type=template&id=4870e6dc"
import script from "./ApplicantsViewer.vue?vue&type=script&lang=ts"
export * from "./ApplicantsViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports